












































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Card } from '@alpha/ink'
import CompletedTest from '@/components/TestDetails/CompletedTest.vue'
import ClassicTestContent from '@/components/TestDetails/ClassicTestContent.vue'
import TemplateManager, { Location } from '@/components/Templates/TemplateManager.vue'
import * as db from '@shared/types/database'
@Component({
  components: {
    Card,
    CompletedTest,
    ClassicTestContent,
    TemplateManager
  }
})

export default class InProgressTest extends Vue {
  @Prop({ required: true }) readonly test!: db.Test
  @Prop({ default: null }) readonly selectedTemplate!: db.Template | null

  location = Location.AddTestModal

  get assets () {
    return this.test.payload.prototypes
  }

  get isTemplated () {
    return !!this.selectedTemplate
  }

  openQueue () {
    this.$router.push({ name: 'queue', params: { testId: this.$route.params.testId } })
  }
}
